import { useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';
import { imChatInfoSelector } from '$store/im';

export function useChatInfo(peerId: number) {
  return useSelector((state: RootState) => imChatInfoSelector(state, peerId));
}
